import { CSSObject } from '@chakra-ui/react';

export const IconRaceAvailableInfo: CSSObject = {
  color: 'white',
};

export const TextRaceAvailability: CSSObject = {
  color: 'white',
};
